import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CanvasStatus, IHedera, IWorld } from 'ngx-hedera';
import { CameraTraslation, Costants, EntityTraslation } from './_model/positions';
import { CanvasService } from './_service/canvas.service';
import { faArrowRight, faArrowLeft, faSearchPlus, faSearchMinus } from '@fortawesome/free-solid-svg-icons';


declare const Hedera: IHedera

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  
  constructor(private http: HttpClient, private canvas: CanvasService) { 
  }

  faArrowRight = faArrowRight;
  faArrowLeft = faArrowLeft;
  faSearchPlus = faSearchPlus;
  faSearchMinus = faSearchMinus;

  world: IWorld;
  updateCounter = 0;
  cameraZoom = 35;

  toggleEsploso = false
  animating = false;
  mainAnimationRunning = false;
  stepAnimationRunning: any = false;

  counter = 0;
  maxStep = Costants.steps.length;
  entities = Costants.entities;

  loading = true; 

  get animationElapsed() { return this.updateCounter * Hedera.delta_time; }

  ngOnInit(): void {
    console.log((document.getElementById('canvas') as any))
    const gl = (document.getElementById('canvas') as any).getContext("webgl", { premultipliedAlpha: false });
  }

  onWheelMove(event) {
    this.cameraZoom -= event.wheelDeltaY * 0.01;
    this.world.setTargetCameraOrbitView(0, 7, 0, this.cameraZoom);
    this.world.translateCameraOrbitView(0, 0, 0);
    this.world.updateCameraOrbitView();
  }

  onZoomClickPlus() {
    this.cameraZoom -= 5;
    this.world.setTargetCameraOrbitView(0, 7, 0, this.cameraZoom);
    this.world.translateCameraOrbitView(0, 0, 0);
    this.world.updateCameraOrbitView();
  }

  onZoomClickMinus() {
    this.cameraZoom += 5;
    this.world.setTargetCameraOrbitView(0, 7, 0, this.cameraZoom);
    this.world.translateCameraOrbitView(0, 0, 0);
    this.world.updateCameraOrbitView();
  }

  onHederaStartup(world) {
    console.log('Hedera start!');
    this.world = world;
    this.canvas.world = world;
      
  
    this.http.get('./assets/test_engine.hpk', { responseType: 'arraybuffer' }).subscribe(arraybuffer => {
      this.world.mainLoopPause();
      this.world.loadHAssetsHpk(arraybuffer); // Carica gli asset nell' esecuzione di Hedera
      this.world.enableOnScreenSelection();

      this.world.setTargetCameraOrbitView(0, 7, 0, this.cameraZoom);
      this.world.translateCameraOrbitView(0, 0, 0);
      this.world.updateCameraOrbitView();

      this.world.mainLoopResume();
      this.loading = false;
    });
  }
  
  onHederaUpdate(status: CanvasStatus) {
    
    if (this.mainAnimationRunning) {
      this.updateCounter++;
      this.updateAnimazionePrincipale();
    }

    if (this.stepAnimationRunning) {
      this.updateCounter++;
      this.updateStepAnimazione();
    }
    
  }

  esplodiMotore() {
    
    Costants.mainAnimationEntityTraslations.forEach(et => {
      const entity = this.entities.find(e => e.entityId === et.entityId);
      entity.translate(this.canvas, et.x, et.y, et.z)
    });
  }

  implodiMotore() {
    Costants.mainAnimationEntityTraslations.forEach(et => {
      const entity = this.entities.find(e => e.entityId === et.entityId);
      entity.reset(this.canvas);
    });
  }

  nextStep() {
    !this.stepAnimationRunning ? this.stepAnimationRunning = 1
      : this.stepAnimationRunning < this.maxStep ? ++this.stepAnimationRunning : null;
    console.log(this.stepAnimationRunning)
    this.startStepAnimation();
  }

  prevStep() {
    if (this.stepAnimationRunning && this.stepAnimationRunning > 0) {
      this.stepAnimationRunning--;
      this.startStepAnimation();
    }
  }

  exitStepMode() {
    this.stepAnimationRunning = false;
    this.entities.forEach(e => e.reset(this.canvas));
  }

  /*  Animazione principale  */

  startMainAnimation() {
    
    if (this.toggleEsploso) {
      this.toggleEsploso = false;
      this.implodiMotore(); 
    }

    this.updateCounter = 0;
    this.animating = true;
    this.mainAnimationRunning = true;
    this.esplodiMotore();
  }

  updateAnimazionePrincipale() {

    this.animating = true;
    Costants.mainAnimationEntityTraslations
      .filter(et => et.start <= this.animationElapsed && et.end > this.animationElapsed)
      .forEach(et => this.animaEntity(et) );

    Costants.cameraTraslations
      .filter(ct => ct.start <= this.animationElapsed && ct.end > this.animationElapsed)
      .forEach(ct => this.animaCamera(ct));

    const animations = [].concat(Costants.mainAnimationEntityTraslations).concat(Costants.cameraTraslations)
    if (this.animationElapsed > Math.max.apply(Math, animations.map(function(o) { return o.end; })) ) {
      this.animating = false;
      this.mainAnimationRunning = false;
    }
  }

  /*  Fine animazione principale  */

  /* Animazione Step */

  startStepAnimation() {

    console.log('start index step', this.stepAnimationRunning - 1)

    if (this.toggleEsploso) {
      this.toggleEsploso = false;
      this.implodiMotore(); 
    }

    this.updateCounter = 0;
    this.animating = true;

    this.entities.forEach(e => e.reset(this.canvas));
    Costants.steps[this.stepAnimationRunning - 1].start.forEach(et => {
      const entity = this.entities.find(e => e.entityId === et.entityId);
      entity.translate(this.canvas, et.x, et.y, et.z)
      if (et.offScene) {
        entity.setOffScene(this.canvas, true);
      }
      // this.canvas.translateEntity(et.entityId, et.x, et.y, et.z)
    });
  }

  updateStepAnimazione() {
    Costants.steps[this.stepAnimationRunning - 1].translate
    .filter(et => et.start <= this.animationElapsed && et.end > this.animationElapsed)
    .forEach(et => this.animaEntity(et) );
  }

  /* FINE - Animazione Step */


  /* Helpers */


  animaEntity(et: EntityTraslation) {
    if (!et.animazioneInCorso) {
      et.animazioneInCorso = true
      const durataMs = (et.end - et.start) * 1000;
      const updateAnimazioneMs = 25

      console.log('Parte animazione: ', et.entityId);
      const interval = setInterval(() => {
        
        const numCicli = (durataMs / updateAnimazioneMs);
        const spostamentoX = et.x / numCicli;
        const spostamentoY = et.y / numCicli;
        const spostamentoZ = et.z / numCicli;

        const entity = this.entities.find(e => e.entityId === et.entityId);
        entity.translate(this.canvas, -spostamentoX, -spostamentoY, -spostamentoZ)

        if (et.rotation) {
          const rotazioneX = et.rotation.x / numCicli;
          const rotazioneY = et.rotation.y / numCicli;
          const rotazioneZ = et.rotation.z / numCicli;

          const hederaEntity = this.world.getEntity(et.entityId)
          this.world.rotate(hederaEntity, rotazioneX, rotazioneY, rotazioneZ);
        }
        

        if (this.animationElapsed >= et.end) {
          console.log('Termina animazione: ', et.entityId);
          et.animazioneInCorso = false;
          this.animating = false;
          clearInterval(interval);
        }
      }, updateAnimazioneMs);
    }
  }

  animaCamera(ct: CameraTraslation) {
    if (!ct.animazioneInCorso) {
      ct.animazioneInCorso = true
      const durataMs = (ct.end - ct.start) * 1000;
      const updateAnimazioneMs = 25

      console.log('Parte animazione camera: ');
      const interval = setInterval(() => {
        
        const numCicli = (durataMs / updateAnimazioneMs);
        const spostamentoX = ct.x / numCicli;
        const spostamentoY = ct.y / numCicli;
        const spostamentoZ = ct.z / numCicli;

        const camera = this.entities.find( e => e.entityId === 'camera');
        camera.translateCamera(this.world, spostamentoX, spostamentoY);

        if (this.animationElapsed >= ct.end) {;
          ct.animazioneInCorso = false;
          clearInterval(interval);
        }
      }, updateAnimazioneMs);
    }
  }



}
